import React from 'react';
import { useAuthentication } from './useAuthentication';

export type AppState = {
    targetPath?: string;
};

export type AuthenticationContextType = {
    isAuthenticated: boolean;
    authToken: string;
    logout: () => void;
    labels: string[];
    artists: string[];
    isLandr: boolean;
    canUploadCsv: boolean;
    providerName: string;
};

export const AuthenticationContext = React.createContext<
    AuthenticationContextType
>({
    isAuthenticated: false,
    authToken: '',
    logout: () => undefined,
    labels: [],
    artists: [],
    isLandr: false,
    canUploadCsv: false,
    providerName: '',
});

interface AuthenticationProviderProps {
    children: React.ReactNode;
}

export const AuthenticationProvider = ({
    children,
}: AuthenticationProviderProps): React.ReactElement => {
    const {
        isAuthenticated,
        authToken,
        logout,
        labels,
        artists,
        isLandr,
        canUploadCsv,
        providerName,
    } = useAuthentication();

    return (
        <AuthenticationContext.Provider
            value={{
                isAuthenticated,
                authToken,
                logout,
                labels,
                artists,
                isLandr,
                canUploadCsv,
                providerName,
            }}
        >
            <>{children}</>
        </AuthenticationContext.Provider>
    );
};
